import React, { useCallback, useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { UserPlus } from 'lucide-react';
import { axios, auth, mbUrl, muted, primary, card, runCall } from './mbApi';

const EVIDENCE = { invite_link: 'Melalui invite link ujian', link_tak_dikenali: 'Link tak dikenali', tiada_link: 'Sumber tak diketahui' };
const KIND = { join: 'Join', leave: 'Keluar', join_request: 'Request join (belum diluluskan)' };

export const JoinsCard = ({ ibId, dash, telegramMode, canManage, onChanged }) => {
  const [events, setEvents] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    try { setEvents((await axios.get(mbUrl(ibId, '/joins'), { ...auth(), params: { limit: 15 } })).data.events); } catch (e) { /* board errors already toasted */ }
  }, [ibId]);
  useEffect(() => { load(); }, [load, dash]);

  const simulate = (kind) => runCall(setBusy, async () => {
    await axios.post(mbUrl(ibId, '/telegram/mock-join'), { kind }, auth());
    onChanged();
  }, 'Mock event recorded');

  const cov = dash?.coverage?.today;
  return (
    <div className={card} data-testid="mb-joins-card">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
        <p className={`text-sm font-semibold ${primary} flex items-center gap-2`}><UserPlus size={15} /> Join Channel (Telegram)</p>
        {canManage && telegramMode === 'mock' && (
          <div className="flex gap-1.5">
            <Button size="sm" variant="outline" className="h-7 text-xs" disabled={busy} onClick={() => simulate('join')} data-testid="mb-sim-join-nolink">Simulate join tanpa link</Button>
            <Button size="sm" variant="outline" className="h-7 text-xs" disabled={busy} onClick={() => simulate('request')} data-testid="mb-sim-request">Simulate join request</Button>
          </div>
        )}
      </div>
      <p className={`text-xs ${muted}`} data-testid="mb-coverage">
        Coverage hari ni: {cov?.total ? `${cov.known}/${cov.total} join ada sumber (${cov.pct}%) · ${cov.unknown} sumber tak diketahui` : 'belum ada join'}
        {dash?.actual?.joins_rejoin_today ? ` · ${dash.actual.joins_rejoin_today} rejoin (dikira)` : ''}
      </p>
      <p className={`text-[11px] ${muted} italic mb-2`}>Join melalui link = bukti guna link, bukan atribusi Meta sempurna. Member snapshot/net growth tak dikira di sini.</p>
      <div className="space-y-1" data-testid="mb-join-events">
        {events.length === 0 && <p className={`text-xs ${muted}`}>Belum ada event.</p>}
        {events.map((e) => (
          <div key={`${e.update_id}`} className={`text-[11px] ${muted} flex flex-wrap gap-2`} data-testid={`mb-join-event-${e.update_id}`}>
            <span className={primary}>{KIND[e.kind] || e.kind}</span>
            {e.classification && <span>{{ rejoin: 'Rejoin (dikira)', baru_dalam_rekod: 'Baru (dalam rekod)', join_berulang_tanpa_keluar: 'Join berulang tanpa keluar (tak dikira)' }[e.classification]}</span>}
            <span>{EVIDENCE[e.evidence]}</span>
            <span>{new Date(e.joined_at).toLocaleString('en-GB')}</span>
            {e.source === 'mock' && <span className="text-amber-400">mock</span>}
          </div>
        ))}
      </div>
    </div>
  );
};
